/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TiktokLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default TiktokLogo;
